import { render, staticRenderFns } from "./post_info.vue?vue&type=template&id=365ff4e9"
import script from "./post_info.vue?vue&type=script&lang=js"
export * from "./post_info.vue?vue&type=script&lang=js"
import style0 from "./post_info.vue?vue&type=style&index=0&id=365ff4e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports